var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.48637 2.66211C7.21435 1.597 8.78554 1.59701 9.51352 2.66212L9.80147 3.08341C11.6055 5.72289 13.1555 8.5273 14.4306 11.4591L14.4908 11.5974C14.9401 12.6305 14.2612 13.8037 13.1415 13.9288C9.72445 14.3107 6.27544 14.3107 2.85836 13.9288C1.73866 13.8037 1.05975 12.6305 1.50912 11.5974L1.56926 11.4591C2.84442 8.5273 4.39439 5.72289 6.19842 3.08341L6.48637 2.66211ZM8.66663 11.5004C8.66663 11.1322 8.36815 10.8337 7.99996 10.8337C7.63177 10.8337 7.33329 11.1322 7.33329 11.5004C7.33329 11.8685 7.63177 12.167 7.99996 12.167C8.36815 12.167 8.66663 11.8685 8.66663 11.5004ZM7.99996 9.66702C8.2761 9.66702 8.49996 9.44317 8.49996 9.16702V5.83369C8.49996 5.55755 8.2761 5.33369 7.99996 5.33369C7.72382 5.33369 7.49996 5.55755 7.49996 5.83369V9.16702C7.49996 9.44317 7.72382 9.66702 7.99996 9.66702Z",
    fill: "#EC494F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle);
export default __webpack_public_path__ + "static/media/warning-triangle.56fa121685eba5d4ab5b9fd067222f14.svg";
export { ForwardRef as ReactComponent };